import React, { useContext, useEffect } from 'react';
import { useLoaderData } from 'react-router-dom';

import { sendScreenEvent } from 'src/utils/analytics';
import { useAtlassianUser } from 'src/hooks/useAtlassianUser';
import { HelmetContext } from 'src/components/Helmet';
import { LearningPathsHubLoaderProps } from 'src/pages/hubs/LearningPathPage/loader';
import { useReferrer } from 'src/hooks/useReferrer';
import { HubLayout } from 'src/pages/hubs/LearningPathPage/children/HubLayout';

export const LearningPathPage: React.FC = () => {
  const { user, isLoading, hasError } = useAtlassianUser();
  const helmet = useContext(HelmetContext);
  const { referrerPath, isInitialized } = useReferrer();

  const { learningPathsHubData } = useLoaderData() as LearningPathsHubLoaderProps;

  helmet.setHelmet({
    title: `${learningPathsHubData.titleExternal} | Learning - Atlassian Community`,
    seoTags: learningPathsHubData.seo,
  });

  useEffect(() => {
    if (!isLoading && !hasError && isInitialized) {
      sendScreenEvent('learningPathsHubScreen', { learningReferrerPath: referrerPath }, user?.account_id);
    }
  }, [user, isLoading, hasError, referrerPath, isInitialized]);

  return <HubLayout hubData={learningPathsHubData} />;
};
